import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_play",
  "use": "icon_play-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"icon_play\"><rect width=\"100\" height=\"100\" rx=\"40\" fill=\"currentColor\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32 30.768c0-3.624 3.68-5.92 6.682-4.169l32.989 19.232c3.105 1.81 3.105 6.527 0 8.338L38.682 73.4C35.68 75.15 32 72.856 32 69.232V30.768z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol